import { ProjectFeedResultAjax } from './project-feed.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    projectFeed: ProjectFeedResultAjax;
  }
}

export const projectFeedBackend = {
  fetch: () => ({
    endpoint: `navigation/project-feed/pre-populated.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed/project-feed.backend.ts